var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "20px",
        width: "20px",
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 370.518 370.518",
        "xml:space": "preserve",
        fill: "#f09a0e",
        transform: "rotate(90)",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("g", [
          _c("path", {
            staticStyle: { fill: "#f09a0e" },
            attrs: {
              d: "M298.259,119.009H210.79l31.844-31.844c1.406-1.407,2.196-3.314,2.196-5.303 c0-1.989-0.79-3.897-2.197-5.304l-14.143-14.142c-2.927-2.929-7.676-2.928-10.605,0l-15.125,15.126V7.5c0-4.142-3.357-7.5-7.5-7.5 h-20c-4.143,0-7.5,3.358-7.5,7.5v70.043l-15.125-15.126c-2.93-2.929-7.679-2.929-10.606,0l-14.143,14.142 c-1.407,1.407-2.197,3.314-2.197,5.304c0,1.989,0.79,3.896,2.196,5.303l31.844,31.844H72.259c-4.143,0-7.5,3.358-7.5,7.5v20 c0,4.142,3.357,7.5,7.5,7.5h226c4.143,0,7.5-3.358,7.5-7.5v-20C305.759,122.367,302.401,119.009,298.259,119.009z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#f09a0e" },
            attrs: {
              d: "M298.259,216.509h-226c-4.143,0-7.5,3.358-7.5,7.5v20c0,4.142,3.357,7.5,7.5,7.5h87.469 l-31.844,31.844c-1.406,1.407-2.196,3.314-2.196,5.303c0,1.989,0.79,3.897,2.197,5.304l14.143,14.142 c2.928,2.929,7.677,2.928,10.606-0.001l15.125-15.125v70.043c0,4.142,3.357,7.5,7.5,7.5h20c4.143,0,7.5-3.358,7.5-7.5v-70.043 l15.125,15.125c1.465,1.465,3.384,2.197,5.304,2.197c1.919,0,3.839-0.732,5.302-2.196l14.143-14.142 c1.407-1.407,2.197-3.315,2.197-5.304c0-1.989-0.79-3.896-2.196-5.303l-31.844-31.844h87.469c4.143,0,7.5-3.358,7.5-7.5v-20 C305.759,219.867,302.401,216.509,298.259,216.509z",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }